var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.298 10.944.213-3.146 5.86-5.148c.259-.23-.054-.342-.397-.14L3.74 6.964.614 5.998c-.672-.186-.68-.64.152-.967L12.95.449c.556-.246 1.09.134.877.967l-2.075 9.528c-.145.677-.565.84-1.145.528L7.45 9.197l-1.518 1.436c-.176.171-.32.312-.633.312"
  })));
};
export default SvgTelegram;